import React from 'react'
import { useTbViewStore } from '@vt/hooks'
import DefaultMap from './maps/map-default'
import MapArea from './maps/map-area'
import MapGeo from './maps/map-geo'
import { showDetail } from '../../details-copy'

/**
 * @file 地图视图
 * @author liuziyun
 */

const Map = function ({ showTbDetail = showDetail }) {
  const mapConfig = useTbViewStore((state) => state.mapConfig)

  if (mapConfig) {
    if (['area', 'marker'].includes(mapConfig.mapType)) {
      return <MapArea showTbDetail={showTbDetail} />
    }

    if (mapConfig.mapType === 'geo') {
      return <MapGeo />
    }
  }

  return <DefaultMap showTbDetail={showTbDetail} />
}

export default Map
